<template>
  <div class="flex items-center">
    <p @click.stop.prevent class="text-inherit hover:text-primary">{{
        (new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        })).format(params.value)
      }}</p>
  </div>
</template>

<script>
export default {
  computed: {
  }
}
</script>
